import { Box, Card, Typography } from '@mui/material'
import React from 'react'
import MaterialBox from '../../../../components/MaterialBox'
import MaterialTypography from '../../../../components/MaterialTypography'

const TotalProjectCountCard = ({ employeeData }) => {
    return (
        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>

            <MaterialBox sx={{ display: 'flex', flexDirection: 'row', gap: 0.3, alignItems: 'center' }}>
                <MaterialBox sx={{ width: '6px', height: '14px', backgroundColor: '#7783c9', borderRadius: 1 }} />
                <MaterialTypography variant="h6" fontWeight="bold" sx={{ fontSize: '1rem' }}>
                    Current Week Task
                </MaterialTypography>
            </MaterialBox>

            <Card
                sx={{
                    // position: "relative",
                    borderRadius: 3,
                    height: "66px",
                    // overflow: "hidden",
                    p: 1,
                    color: "#fff",
                    background: `linear-gradient(135deg, #646987 0%, #CDE1F1 100%)`,
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5px',
                    alignItems: 'center'
                }}
            >
                <MaterialBox sx={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                    <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "bold" }}
                    >
                        Total Task :
                    </Typography>

                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: "bold",
                            color: '#fff'
                        }}
                    >
                        {employeeData?.task_status_summary?.total_tasks}
                    </Typography>
                </MaterialBox>
            </Card>
        </MaterialBox>
    )
}

export default TotalProjectCountCard
